import { client } from 'repositories/client';
import { paths } from 'repositories/oauth/paths';
import {
  AuthorizationTokenResponse,
  IphoneRegistrationTokenResponse,
} from 'repositories/oauth/responseType';

const authorizationToken = async (onetimeToken: string): Promise<string> => {
  const params = new FormData();
  params.append('onetime_token', onetimeToken);
  const response = await client.post<AuthorizationTokenResponse>(
    paths.authorizationToken,
    params
  );
  return response.data.results.authorization_token;
};

const iphoneRegistrationToken = async (
  onetimeToken: string
): Promise<string> => {
  const params = new FormData();
  params.append('onetime_token', onetimeToken);
  const response = await client.post<IphoneRegistrationTokenResponse>(
    paths.iphoneRegistrationToken,
    params
  );
  return response.data.results.iphone_registration_token;
};

export const oauth = {
  authorizationToken,
  iphoneRegistrationToken,
};
